import templateUrl from "webutils/ibox/ibox.htm";

export class IboxController {
  constructor($transclude) {
    this.hasRawHeader = $transclude.isSlotFilled("rawHeader");
    this.hasHeaderIbox = $transclude.isSlotFilled("headerIbox");
    this.hasToolbar = $transclude.isSlotFilled("toolbar");
    //this.hasContent = $transclude.isSlotFilled("");
  }
  toggle() {
    return (this.collapsed = !this.collapsed);
  }
}

export default {
  bindings: {
    collapsed: "=?",
    closed: "=?",
    headerTitle: "@",
    class: "@",
    classes: "@",
    titleClasses: "@",
    contentClasses: "@",
    contentOnly: "@",
    icon: "@",
    hideHeader: "@", //Use if no content in the header
    cantClose: "@",
    cantToggle: "@",
    noPadding: "@", // Use if not content in ibox-content div
    type: "@",
    raw: "@",
    floatE: "@"
  },
  transclude: {
    rawHeader: "?rawHeader",
    headerIbox: "?headerIbox",
    toolbar: "?toolbar"
  },
  templateUrl($element, $attrs) {
    return $attrs.templateUrl || templateUrl;
  },
  controller: IboxController
};
